import React from 'react';
import {
  BlockProduct,
  BlockProductListSkeleton,
} from '@views/components/block/Block';

export const Placeholder = () => (
  <BlockProduct>
    <BlockProduct.Body>
      <BlockProduct.List>
        <BlockProductListSkeleton number={6} />
      </BlockProduct.List>
    </BlockProduct.Body>
  </BlockProduct>
);

export default Placeholder;
